export const ON_SEARCH_TEXT_CHANGED = 'DM_SEARCH.ON_SEARCH_TEXT_CHANGED';
export const ON_SEARCH_BTN_CLICKED = 'DM_SEARCH.ON_SEARCH_BTN_CLICKED';
export const SET_SEARCH_RESULTS = 'DM_SEARCH.SET_SEARCH_RESULTS';
export const SET_SHOWING_TYPE = 'DM_SEARCH.SET_SHOWING_TYPE';
export const ON_SEARCH_OPTION_CHANGED = 'DM_SEARCH.ON_SEARCH_OPTION_CHANGED';
export const SET_SEARCH_OPTIONS_ACTION = 'DM_SEARCH.SET_SEARCH_OPTIONS_ACTION';
export const SET_LOADING_STATUS = 'DM_SEARCH.SET_LOADING_STATUS';
export const ON_RESULT_ITEM_CLICKED = 'DM_SEARCH.ON_RESULT_ITEM_CLICKED';
export const RESET_DATA = 'DM_SEARCH.RESET_DATA';
export const ON_SELECT_OWNER_CLICKED = 'DM_SEARCH.ON_SELECT_OWNER_CLICKED';
export const ON_EXPORT_EXCEL_BTN_CLICKED = 'DM_SEARCH.ON_EXPORT_EXCEL_BTN_CLICKED';
